import React from 'react';
import { useFormikContext } from 'formik';
import { useLocation } from 'react-router-dom';

import { fieldToStep } from './initialValues';

let defaultCb = (_v: object) => {};
let cb = defaultCb;

const defaultValue = {
  'General Info': 0,
  'Business Profile': 0,
  'Capabilities': 0,
  'Past Performance': 0,
  'Bonding': 0,
  'Insurance and Safety': 0,
  'Security and Certifications': 0,
  'Compliance': 0,
  'Signature': 0,
} as { [key: string]: number };
let value = { ...defaultValue };

const subscribe = (fn: (v: object) => void) => {
  cb = fn;
  cb(value);
  return () => {
    cb = defaultCb;
  }
}

const TallyErrors = () => {
  const { errors } = useFormikContext();
  const { pathname } = useLocation();

  React.useEffect(() => {
    const tallies = { ...defaultValue };
    Object.keys(errors).forEach(field => {
      // @ts-ignore
      tallies[fieldToStep[field]] += 1;
    });
    value = tallies;
    cb(value);
  }, [pathname])

  return null;
}

export default TallyErrors;
export { subscribe };
